import { useContext } from "react"
import { Col, Container, Row } from "react-bootstrap"
import { withTranslation } from "react-i18next"

import ReporteCitasPendientes from "../../components/reportes/ReporteCitasPendientes"
import ReporteNotificacionReasignacion from "../../components/reportes/ReporteNotificacionReasignacion"
import { authContext } from "../../context/AuthContext"

function ReportesCalidad({t}){    
    const {auth} = useContext(authContext)   

    return (
        <Container fluid className="my-5">
            <Row className="my-3">
                <Col xs="12" md="12">
                    <ReporteCitasPendientes auth={auth}/>
                </Col>
            </Row>
            <Row>
                <Col xs="12" md="12">
                    <ReporteNotificacionReasignacion auth={auth}/>
                </Col>
            </Row>
        </Container>
    )


}

export default withTranslation()(ReportesCalidad)